
import { VENDOR_JOB_DETAILS_REQUEST, VENDOR_JOB_DETAILS_SUCCESS, VENDOR_JOB_DETAILS_FAIL, VENDOR_JOB_UPDATE_REQUEST, VENDOR_JOB_UPDATE_FAIL, VENDOR_JOB_UPDATE_SUCCESS } from "../constants/AuthConstant"
import { toast } from "react-toastify";

const axios = require("axios");

export const JobsDetails = (id) => {
    return function (dispatch) {
        dispatch({
            type: VENDOR_JOB_DETAILS_REQUEST,
            payload: true,
        });

        let OPTION = {
            url: `${process.env.REACT_APP_API_PATH}/ebench/get_job_by_jobId?jobId=${id}`,
            method: "GET",
            headers: {
                "content-type": "application/json",
            },
        };
        axios(OPTION)
            .then((res) => {
                // console.log(res.data, "hello")
                dispatch(loadAllDetailsPre(res.data));
            })
            .catch((error) => {
                dispatch({
                    type: VENDOR_JOB_DETAILS_FAIL,
                    payload: false,
                    error: error,
                    msg: "Failed to load the information",
                });
            });
    };
};

export const loadAllDetailsPre = (data) => {
    return {
        type: VENDOR_JOB_DETAILS_SUCCESS,
        result: data,
        payload: false,
        loading: false,
        msg: "SUCCESS",
    };
};

export const VendorJobUpdate = (data, navigate) => {
    console.log('DAT--', data)

    const formData = new FormData();
    formData.append('jobs', JSON.stringify(data.jobs));
    formData.append('file', data.file);
    return function (dispatch) {
        dispatch({
            type: VENDOR_JOB_UPDATE_REQUEST,
            payload: true,
        });
        let OPTION = {
            url: `${process.env.REACT_APP_API_PATH}/ebench/update_jobs`,
            method: "PUT",
            data: formData,
            headers: {
                // "content-type": "application/json",
                "content-Type": "multipart/form-data",
            },
        };

        axios(OPTION)
            .then((res) => {
                dispatch(updateJobPre(res.data, navigate));
                // toast.success("Job Posted Successfully!");
            })
            .catch((error) => {
                dispatch({
                    type: VENDOR_JOB_UPDATE_FAIL,
                    payload: false,
                    error: error,
                    msg: "Failed to load the information",
                });
                toast.error("Failed To Update The DashboardContent!");
            });
    };
};
export const updateJobPre = (data, navigate) => {
    // toast.success("Job Updated Successfully!");
    // setTimeout(() => {
    //     window.location.href = "/posted_jobs"
    // }, 2000)
    return {
        type: VENDOR_JOB_UPDATE_SUCCESS,
        result: data,
        payload: false,
        msg: "SUCCESS",
    };
};